import axios from "axios";
import Config from "../Config";
import RequestUtil from "@/utils/RequestUtil.js";

export default {
  // 공통 API 영역
  //
  // 세션키 생성 API
  getSessionKey(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/request/sessionkey";
    return axios.post(url, param, config);
  },
  // 약관 목록 API
  getTermList(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/need/terms" + RequestUtil.getPasingParam(param);
    return axios.get(url, config);
  },
  // 회원 정보 조회 API
  getUserInfo(config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user";
    return axios.get(url, config);
  },
  // 이투스 중복 아이디 정보 조회 API
  getDuplicatedAccountInfo(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/etoos/get/duplicate/id`;
    return axios.post(url, param, config);
  },
  // 추천 정보 조회 API
  getUserRecommendInformation(serviceId, param, config) {
    const url = Config.API_DOMAIN + `/etoos/members/v1/service/${serviceId}/recommend/profile`;
    return axios.post(url, param, config);
  },
  // 서비스별 회원유형 목록 조회 API
  getServiceUserTypeList(config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/need/type";
    return axios.get(url, config);
  },
  // 통합 회원가입 API 영역
  //
  // 통합 회원가입 회원유형 등록 API
  insertRegisterUserType(param, config) {
    const url = Config.API_DOMAIN + `/ext/members/v1/signup/save/type`;
    return axios.post(url, param, config);
  },
  // 약관 동의 API
  insertTerm(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/signup/terms";
    return axios.post(url, param, config);
  },
  // 통합 회원가입 API
  insertIntegratedRegister(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/signup/registration";
    return axios.post(url, param, config);
  },
  // 통합 SNS 회원가입 API
  insertIntegratedSocialRegister(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/signup/registration/sns";
    return axios.post(url, param, config);
  },
  // 서비스 회원가입 API 영역
  //
  // 서비스별 회원유형 등록 API
  insertServiceUserType(serviceId, param, config) {
    const url = Config.API_DOMAIN + `/ext/members/v1/service/${serviceId}/save/type`;
    return axios.post(url, param, config);
  },
  // 서비스 약관 등록 API
  insertServiceTerm(serviceId, param, config) {
    const url = Config.API_DOMAIN + `/ext/members/v1/service/${serviceId}/terms`;
    return axios.post(url, param, config);
  },
  // 서비스 등록 API
  insertService(serviceId, param, config) {
    const url = Config.API_DOMAIN + `/ext/members/v1/service/${serviceId}/registration`;
    return axios.post(url, param, config);
  },
  /**
   * 14세 미만 여부 체크 API
   * @return boolean
   * */
  getLegalCheck(headerOption) {
    return axios.get(`${Config.API_DOMAIN}/etoos/members/v1/service/check/legal`, {
      headers: headerOption
    });
  },
  checkServiceIdType(serviceId, param, config) {
    const url = `${Config.API_DOMAIN}/etoos/members/v1/service/check/${serviceId}/type`;
    return axios.post(url, param, config);
  }
};
